<template>
  <div>
    <b-row>
      <b-col>
        <b-card>
          <b-row class="mt-2">
            <b-col sm="auto" class="text-center">
              <div class="profile-logo">
                <b-img v-if="!profile.logo.imgBase64" src="/img/icon/No_image.png" />
                <b-img v-else :src="'data:image/jpeg;base64,'+profile.logo.imgBase64" />
              </div>
            </b-col>
            <b-col cols="8" align-self="center">
              <b-row>
                <b-col sm="12" md="6" align-self="center">
                  <span class="text-muted">ผู้ว่าจ้าง</span>
                  <br />
                  <div class="text-logisty-dark-main profile-company-name">
                    <b>{{ profile.name }}</b>
                  </div>
                  <div class="text-muted profile-company-address">{{ profile.address }}</div>
                  <span class="mr-2" v-for="item in profile.businessType" :key="item"><b-badge variant="logisty-dark-main">{{ item }}</b-badge></span>
                </b-col>
                <b-col v-if="showStatus || quote.status < 20" sm="12" md="6" align-self="center">
                  <span class="text-muted">ผู้รับผิดชอบงาน</span>
                  <b>
                    <br />
                    <span class="text-logisty-dark-main">{{ quote.contactName }}</span>
                    <br />
                    <span class="text-logisty-dark-main">{{ quote.contactNumber }}</span>
                    <span class="text-logisty-dark-main" v-if="quote.contactEmail">
                      <br />
                      {{ quote.contactEmail }}
                    </span>
                  </b>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <hr class="divider" />
          <b-row>
            <b-col sm="12" md="3">
              <span class="text-muted">ลักษณะงาน</span>
              <br />
              <b>{{ quote.jobType }}</b>
            </b-col>
            <b-col sm="12" md="3">
              <span class="text-muted">วันที่เริ่มงาน</span>
              <br />
              <b>{{ $moment(quote.startDate).format('LL') }}</b>
            </b-col>
            <b-col sm="12" md="3">
              <span class="text-muted">ระยะเวลางาน</span>
              <br />
              <b>{{ quote.period ? quote.period : '-' }} {{ quote.periodUnit ? quote.periodUnit : '' }}</b>
            </b-col>
            <!-- <b-col sm="12" md="3">
              <span class="text-muted">ผู้รับผิดชอบ</span>
              <b>
                <br />
                {{ quote.contactName }}
                <br />
                {{ quote.contactNumber }}
                <span v-if="quote.contactEmail">
                  <br />
                  {{ quote.contactEmail }}
                </span>
              </b>
            </b-col> -->
            <b-col v-if="showStatus" sm="12" md="3">
              <span class="text-muted">สถานะ</span>
              <br />
              <h5><b-badge :variant="jobStatus.find( x => x.value == quote.status).variant">{{ jobStatus.find( x => x.value == quote.status).text }}</b-badge></h5>
            </b-col>
          </b-row>
          <!-- <b-row>
            <b-col>
              <b-link
                class="float-right"
                :to="{name: 'โปรไฟล์', params: {companyUrl:profile.profileUrl}}"
              >ดูข้อมูลบริษัท</b-link>
            </b-col>
          </b-row>-->
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <h5 class="text-logisty-dark-main">รายละเอียดรถที่ต้องการ</h5>
          <!-- <b-row>
            <b-col sm="4" md="3">
              <span class="text-muted">จำนวนรถที่ใช้</span>
            </b-col>
            <b-col sm="8" md="9">{{ quote.truckNum ? quote.truckNum : '-' }} คัน</b-col>
          </b-row> -->
          <b-row>
            <b-col sm="4" md="3">
              <span class="text-muted">ความถี่</span>
            </b-col>
            <b-col sm="8" md="9">{{ quote.frequency }} {{ quote.frequencyType }}</b-col>
          </b-row>
          <hr class="divider" />
          <b-row>
            <b-col>
              <h6 class="text-logisty-profile-heading">ประเภทรถที่ใช้</h6>
              <b-row class="text-center">
                <b-col
                  v-for="(item,index) in quote.truckType"
                  v-bind:key="index"
                  sm="12"
                  md="4"
                  lg="3"
                >
                  <b-img class="logisty-truck-icon" :src="'/img/truck_icon/' + getIcon(item)" fluid></b-img>
                  <br />
                  {{ getTypeName(item) }}
                  <br />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <hr class="divider" />
          <b-row>
            <b-col>
              <h6 class="text-logisty-profile-heading">สถานที่ขึ้น/ลง สินค้า</h6>
              <b-row class="mt-2">
                <b-col sm="12" md="6">
                  <span class="text-muted">ต้นทาง</span>
                  <br />
                  <span v-for="(item,index) in quote.origin" :key="index">
                    {{ item.region }}
                    <span v-if="index != quote.origin.length -1">,</span>
                  </span>
                  <br />
                  <br />
                  <span class="text-muted">สถานที่ / อำเภอ / จังหวัด</span>
                  <br />
                  {{ quote.originPlace ? quote.originPlace : '-' }}
                  <br />
                  <br />
                </b-col>
                <b-col sm="12" md="6">
                  <span class="text-muted">ปลายทาง</span>
                  <br />
                  <span v-for="(item,index) in quote.destination" :key="index">
                    {{ item.region }}
                    <span v-if="index != quote.destination.length -1">,</span>
                  </span>
                  <br />
                  <br />
                  <span class="text-muted">สถานที่ / อำเภอ / จังหวัด</span>
                  <br />
                  {{ quote.destinationPlace ? quote.destinationPlace : '-' }}
                  <br />
                  <br />
                </b-col>
              </b-row>
              <b-row v-if="$router.currentRoute.name != 'รายละเอียดใบขอราคาของฉัน'">
                <b-col>
                  <span class="text-muted">แบบฟอร์มเสนอราคา (จากผู้ว่าจ้าง)</span>
                  <FileListInQuote class="mt-3" ref="shipperQuoteFileList" :refId="quote._id" docType="carrier-quote" :preventDelete="true" docClass="request"/>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <hr class="divider" />
          <b-row>
            <b-col>
              <h6 class="text-logisty-profile-heading">ข้อกำหนดอื่น ๆ</h6>
              <b-row class="mt-2">
                <b-col>
                  <span class="text-muted">ประกันสินค้า</span>
                  <br />
                  {{ quote.truckCargoInsuranceCoverage ? quote.truckCargoInsuranceCoverage : '0' }} บาทขึ้นไป
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col>
                  <span class="text-muted">รายละเอียดพิเศษ</span>
                  <br />
                  {{ quote.specialRequirement ? quote.specialRequirement : '-' }}
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col>
                  <span class="text-muted">การโหลดสินค้าขึ้นลง</span>
                  <br />
                  {{ quote.loadingDetails ? quote.loadingDetails : '-' }}
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <h5 class="text-logisty-dark-main">รายละเอียดสินค้า</h5>
          <div class="text-muted mb-1">ลักษณะสินค้า</div>
          <p>{{ quote.goodsDescriptions ? quote.goodsDescriptions : 'ไม่ระบุ' }}</p>
          <hr class="divider" />
          <b-row>
            <b-col sm="4" md="3">
              <span class="text-muted">น้ำหนักสินค้า</span>
            </b-col>
            <b-col sm="8" md="9">{{ quote.totalGoodsWeight }} {{ quote.totalGoodsWeightUnit }}</b-col>
          </b-row>
          <b-row>
            <b-col sm="4" md="3">
              <span class="text-muted">จำนวนจุดขึ้นต่อเที่ยว</span>
            </b-col>
            <b-col sm="8" md="9">{{ quote.maxOriginNumber ? quote.maxOriginNumber : '-' }} จุด</b-col>
          </b-row>
          <b-row>
            <b-col sm="4" md="3">
              <span class="text-muted">จำนวนจุดลงต่อเที่ยว</span>
            </b-col>
            <b-col
              sm="8"
              md="9"
            >{{ quote.maxDestinationNumber ? quote.maxDestinationNumber : '-' }} จุด</b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <h5 class="text-logisty-dark-main">รูปแบบการจ่ายเงิน</h5>
          <span>{{ quote.paymentDetails ? quote.paymentDetails : 'ไม่ระบุ' }}</span>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <h5 class="text-logisty-dark-main">หมายเหตุอื่น ๆ</h5>
          <span>{{ quote.remark ? quote.remark : 'ไม่ระบุ' }}</span>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import FileListInQuote from '../../components/FileListInQuote'
import Quote from '../../services/http/Quote'
export default {
  components: {
    FileListInQuote
  },
  props: {
    quote: {
      default: null,
      required: true
    },
    profile: {
      default: null,
      required: true
    },
    showStatus: {
      default: false,
      required: false
    }
  },
  data () {
    return {
      truckIconData: [],
      jobStatus: [
        { value: '0', text: 'ร่าง', variant: 'info' },
        { value: '2', text: 'รอเผยแพร่', variant: 'info' },
        { value: '5', text: 'เผยแพร่', variant: 'primary' },
        { value: '7', text: 'มีคนส่งเอกสาร', variant: 'primary' },
        { value: '20', text: 'ปิดงาน', variant: 'success' }
      ]
    }
  },
  async mounted () {
    await this.$store.dispatch('loadTruckType')
    this.truckIconData = this.$store.state.truckType
    // do update opened log
    if (!this.quote.opened) {
      let data = {
        qrJobIdList: [this.quote._id],
        viewed: true,
        opened: true
      }

      let quoteHttp = new Quote()
      quoteHttp.publicUpdateJobLog(data)
    }
  },
  methods: {
    getIcon (key) {
      var ret = this.truckIconData.find(x => x._id === key)
      if (ret) {
        return ret.icon
      } else {
        return 'truck_normal.png'
      }
    },
    getTypeName (key) {
      var ret = this.truckIconData.find(x => x._id === key)
      if (ret) {
        return ret.typeName
      } else {
        return 'unknown'
      }
    }
  }
}
</script>
